/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-destructuring */
import axios from 'axios';
import moment from 'moment';
import i18 from '../lang/i18n';
// import { dataURItoBlob } from './common';
import { FACE_DETECT_RESULTS } from './consts';
import { API_URL } from '../circulusConfig';

export const MAIL_REGEXP = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
export const TEL_REGEXP = /^0([1|7])([0|1|6|7|8|9|0]?)?([0-9]{7,8})$/g;
export const PW_REGEXP = /(((?=.*[a-zA-Z])(?=.*\d))|((?=.*[a-zA-Z])(?=.*[-~!@#$%^&*_+=;:,.?]))|((?=.*\d)(?=.*[-~!@#$%^&*_+=;:,.?]))|((?=.*[a-z])(?=.*[A-Z])))[A-Za-z\d-~!@#$%^&*_+=;:,.?]{8,20}$/;
export const ID_REGEXP = /(^[a-zA-Z]+[a-zA-Z0-9._-]+[a-zA-Z0-9]{1,12}$)/g;

export const validateId = value => {
  if (!isNaN(value.charAt(0))) {
    return i18.t('user:ID.VALID.NUM');
  }
  if (value.length < 4 || value.length > 14) {
    return i18.t('user:ID.VALID.LENGTH');
  }
  // eslint-disable-next-line no-useless-escape
  if (value.charAt(value.length - 1).search(/[.\-\_]/) > -1) {
    return i18.t('user:ID.VALID.END');
  }
  if (!new RegExp(ID_REGEXP, 'g').test(value)) {
    return i18.t('user:ID.VALID.CHAR');
  }
  return false;
};

export const validatePassword = value => {
  if (!new RegExp(PW_REGEXP, 'g').test(value)) {
    return i18.t('user:PW.VALID.CHAR_LENG');
  }
  return '';
};

export const validateComparePassword = (value, compareValue) => {
  if (compareValue && compareValue.length > 0 && value !== compareValue) {
    return i18.t('user:PW.MSG.UNMATCH');
  }
  return '';
};

export const validateName = (value, item) => {
  const target =
    item === 'lastName' ? i18.t('user:NAME.LAST') : i18.t('user:NAME.FIRST');
  if (!value) {
    return i18.t('user:NAME.INPUT_TARGET', { target });
  }
  const expression = i18.t('user:NAME.REGEXP');
  const nameRegExp = new RegExp(expression, 'ig');
  if (value.match(nameRegExp) > -1) {
    return i18.t('user:NAME.UNVALID.CHAR', { target });
  }
  if (value.length > 30) {
    return i18.t('user:NAME.VALID.LENGTH', { target });
  }
  return '';
};

export const validateNick = value => {
  if (!value) {
    return i18.t('user:NICK.INPUT');
  }
  const expression = i18.t('user:NICK.REGEXP');
  const nameRegExp = new RegExp(expression, 'ig');
  if (value.match(nameRegExp) > -1) {
    return i18.t('user:NICK.UNVALID.CHAR');
  }
  if (value.length > 20) {
    return i18.t('user:NICK.VALID.LENGTH');
  }
  return '';
};

export const validateBirthDate = value => {
  if (!value) {
    return i18.t('user:BIRTH.SELECT');
  }
  const today = moment().format('YYYY-MM-DD');
  const birth = moment(value, 'YYYY-MM-DD');
  if (!(birth.isValid() && birth.isSameOrBefore(today))) {
    return i18.t('user:BIRTH.UNVALID');
  }
  return '';
};

export const validateTel = data => {
  let tel;
  let verified = false;
  if ('value' in data) {
    tel = data.value;
  } else if ('tel' in data) {
    tel = data.tel;
  }
  if (!tel && 'verified' in data) {
    verified = data.verified.email;
    if (!verified) {
      return i18.t('user:TEL.UNVALID');
    }
    return '';
  }
  const validPattern = new RegExp(TEL_REGEXP, 'g').test(tel);
  if (!validPattern) {
    return i18.t('user:TEL.UNVALID');
  }
  return '';
};

export const validateEmail = data => {
  let email;
  let verified = false;
  if ('value' in data) {
    email = data.value;
  } else if ('email' in data) {
    email = data.email;
  }
  if (!email && 'verified' in data) {
    verified = data.verified.tel;
    if (!verified) {
      return i18.t('user:MAIL.UNVALID');
    }
    return '';
  }
  const validPattern = new RegExp(MAIL_REGEXP).test(email);
  if (!validPattern) {
    return i18.t('user:MAIL.UNVALID');
  }
  return '';
};

export const validateInterest = value => {
  if (value.length === 0) {
    return i18.t('user:INTEREST.MSG.LEAST');
  }
  if (value.length > 5) {
    return i18.t('user:INTEREST.VALID.LENGTH');
  }
  return '';
};

export const validateImage = async value => {
  if (!value) {
    return i18.t('user:SET.MSG.UPLOAD_IMG');
  }

  const blob = value;
  const formData = new FormData();
  formData.append('file', blob);
  if (!blob) return '';
  if (typeof blob === 'string') return '';
  try {
    const detectResult = await axios({
      url: `${API_URL}user/face_detect`,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
        'cache-control': 'no-cache',
        processData: false,
        contentType: false,
        mimeType: 'multipart/form-data',
      },
      data: formData,
    });
    const {
      data: { result, d, error: e },
    } = detectResult;
    if (result) {
      const { msg } = FACE_DETECT_RESULTS.find(({ code }) => code === d.status);
      if (msg) {
        return i18.t(msg);
      }
    } else {
      return JSON.stringify(e);
    }
  } catch (e) {
    return i18.t('user:IMG.MSG.CATCH_ERROR');
  }

  return '';
};

export const validateInfos = async ({ value, name }) => {
  let msg = false;
  switch (name) {
    case 'imageFile':
      msg = await validateImage(value);
      break;
    case 'nickName':
      msg = validateNick(value);
      break;
    case 'email':
      msg = validateEmail(value);
      break;
    case 'tel':
      msg = validateTel(value);
      break;
    case 'birthDate':
      msg = validateBirthDate(value);
      break;
    case 'interest':
      msg = validateInterest(value);
      break;
    case 'firstName':
    case 'lastName':
      msg = validateName(value, name);
      break;
    default:
      break;
  }
  if (!msg && name === 'email') {
    const { email, verified, sent } = value;
    if (email && verified && !verified.email && !sent) {
      return { verified: { email: i18.t('user:SIGN_UP.MSG.REQUEST_MAIL') } };
    }
    if (sent && verified && !verified.email) {
      return { verified: { email: i18.t('user:SIGN_UP.MSG.COMPLETE_MAIL') } };
    }
  }
  if (!msg && name === 'tel') {
    const { tel, verified, sent } = value;
    if (tel && verified && !verified.tel && !sent) {
      return { verified: { tel: i18.t('user:SIGN_UP.MSG.REQUEST_TEL') } };
    }
    if (sent && verified && !verified.tel) {
      return { verified: { tel: i18.t('user:SIGN_UP.MSG.COMPLETE_TEL') } };
    }
  }
  return { [name]: msg };
};

export const validateAll = async user => {
  let msg = '';
  if (user) {
    const {
      birthDate,
      email,
      firstName,
      gender,
      interest,
      lastName,
      nickName,
      data,
      image,
    } = user;
    const validItemArr = [
      { name: 'imageFile', value: data || image },
      { name: 'lastName', value: lastName },
      { name: 'firstName', value: firstName },
      { name: 'gender', value: gender },
      { name: 'nickName', value: nickName },
      { name: 'email', value: email },
      { name: 'birthDate', value: birthDate },
      { name: 'interest', value: interest },
    ];
    for (let i = 0; i < validItemArr.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      msg = await validateInfos(validItemArr[i]);
      if (msg) {
        return msg;
      }
    }
  }

  return msg;
};
